/*eslint no-unused-vars: ["off"]*/
/*eslint no-console: ["off"]*/

/*
*   This content is licensed according to the W3C Software License at
*   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
*
*   Simple accordion pattern example
*/

'use strict';

// Fetch all the details element.
const details = document.querySelectorAll("details");

// toggle expandable & add hash
details.forEach((detail) => {
	detail.addEventListener("toggle", () => {
		if (detail.open) {
			closeOthersThenTarget(detail);
			detail.parentNode.classList.add('hsk__card_open');
			// console.log('open');
			let item = detail.parentNode;
			window.location.hash = item.getAttribute('id');
			setTimeout(() => {
				scrollToItem(item);
			}, 750);
		}
	});
});

// close all the details that are not targetDetail.
function closeOthersThenTarget(targetDetail) {
	details.forEach((detail) => {
		if (detail !== targetDetail) {
			detail.open = false;
			detail.parentNode.classList.remove('hsk__card_open');
		}
	});
}

// scroll to expandable
function scrollToItem(item) {
	// console.log('scrollToItem', item);
	const headerOffset = 30;
	const elementPosition = item.getBoundingClientRect().top;
	const offsetPosition = elementPosition + window.scrollY - headerOffset;
	// only scrollto if above
	if (elementPosition < 0 || elementPosition > 400) {
		window.scrollTo({
			top: offsetPosition,
			behavior: "smooth"
		});
	}
}

function checkHash(item) {
	const hash = window.location.hash;
	const hashId = hash.split('#')[1];
	if (item.getAttribute('id') == hashId) {
		item.querySelector('details').setAttribute('open', '');
		// console.log(item.querySelectorAll('details'));
	}
}

function openByHash() {
	// get accordion items
	const items = document.querySelectorAll('.a-exp');
	items.forEach((item) => {
		// remote open by hash
		checkHash(item);
	});
}

document.addEventListener('DOMContentLoaded', openByHash);
window.addEventListener("hashchange", openByHash);
